module.exports = __webpack_public_path__ + "img/rakete.1d70dac.svg";